import { render } from "./FormFileDropper.vue?vue&type=template&id=b32df98a"
import script from "./FormFileDropper.vue?vue&type=script&lang=js"
export * from "./FormFileDropper.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__